import React from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";

const PreviewModal = ({ preview, closePreviewModal, previewImg, selectedLogoType }) => {
  return (
    <Modal show={preview} onHide={closePreviewModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>{selectedLogoType} Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <img
          src={previewImg}
          className="img-fluid"
          // style={{ height: "30rem" }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button text="Close" callBack={closePreviewModal} />
      </Modal.Footer>
    </Modal>
  );
};

export default PreviewModal;
